export function setUsersLoading (state, loading = false) {
  state.usersLoading = loading
}

export function setUsers (state, users) {
  state.users = users.data
  state.usersCurrentPage = users.current_page
  state.usersLastPage = users.last_page
  state.usersPerPage = users.per_page
  state.usersTotal = users.total
}

export function setRoles (state, roles) {
  state.roles = []
  for (var key in roles) {
    state.roles.push(roles[key])
  }
}

export function setOnlineUsers (state, users) {
  state.onlineUsers = users
}

export function addOnlineUsers (state, user) {
  if (!state.onlineUsers.find(ou => ou._id === user._id)) {
    state.onlineUsers.push(user)
  }
}

export function remOnlineUsers (state, user) {
  state.onlineUsers = state.onlineUsers.filter(ou => (ou._id !== user._id))
}

export function setIndexPage (state, page = null) {
  state.indexPage = page
}
